import { render, staticRenderFns } from "./quick_noter.vue?vue&type=template&id=2db3deee&"
import script from "./quick_noter.vue?vue&type=script&lang=js&"
export * from "./quick_noter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports